export default function StatusBadge({ status }) {
    const map = {
        active: { bg: "#4A6D52", label: "Active" },
        redeemed: { bg: "#C48464", label: "Redeemed" },
        expired: { bg: "#7A726D", label: "Expired" },
        void: { bg: "#B24A45", label: "Void" },
    };
    const s = map[status] || map.void;
    return (
        <span
            data-testid={`status-badge-${status}`}
            className="inline-block px-2 py-0.5 rounded-sm text-xs font-medium tracking-wide uppercase text-white"
            style={{ backgroundColor: s.bg }}
        >
            {s.label}
        </span>
    );
}
